// Indicateur unique d'anonymisation d'un allocataire (§ 13.2 de la spec) —
// le détail expose `deletedAt` quand le dossier est anonymisé (flux ou
// stock) ; les listes à actions exposent `allocataireAnonymise` (Task B) ;
// jamais de statut dédié en dur ailleurs.
export function estAnonymise(allocataire) {
  return !!allocataire?.deletedAt || allocataire?.allocataireAnonymise === true;
}
